/* Modules */
import { channel } from "redux-saga";
import { all, fork, takeLatest, put, call, take } from "redux-saga/effects";
import axios from "axios";
import { setReferralView, renewPolicyCall } from "../../helpers/services";

/* Asteroid */
import asteroid from "../../asteroid";

/* Actions */
import DTActions from "./actions";

function FetchCarsData() {
  return asteroid.call("getAutosAPI");
}

function FetchCyclesData() {
  return asteroid.call("getMotosAPI");
}

function FetchIntercomHash(email, recaptcha) {
  return asteroid.call( "generateIntercomHash", {
    email: email,
    recaptcha: recaptcha
  });
}


function* takeOneAndBlock(pattern, worker, ...args) {
  const task = yield fork(function* () {
    while (true) {
      const action = yield take(pattern)
      yield call(worker, ...args, action)
    }
  })
  return task
}

async function FetchUserIP() {
  try {
    let get_ip_response = await axios.get("https://api.ipify.org");

    if (get_ip_response.data) {
      return get_ip_response.data;
    }
  } catch (error) {
    console.log("get_ip_response", "catch", "error", error);
  }
}

export function* GetCarsApiData() {
  yield takeLatest(DTActions.REQUEST_CARS_API, function*() {
    try {
      const cars_api_data = yield call(FetchCarsData);
      yield put({
        type: DTActions.CARS_API_DATA,
        cars_api_data,
      });
    } catch (error) {
      const cars_api_data = null;
      yield put({ type: DTActions.CARS_API_DATA, cars_api_data });
    }
  });
}

export function* GetCyclesApiData() {
  yield takeLatest(DTActions.REQUEST_CYCLES_API, function*() {
    try {
      const cycles_api_data = yield call(FetchCyclesData);
      yield put({
        type: DTActions.CYCLES_API_DATA,
        cycles_api_data,
      });
    } catch (error) {
      const cycles_api_data = null;
      yield put({ type: DTActions.CYCLES_API_DATA, cycles_api_data });
    }
  });
}

const my_payload_channel = channel();

export function* helloSaga() {
  
  const payload = "Hello World";

  my_payload_channel.put({
    type: DTActions.CARS_API_DATA,
    payload,
  });

  while (true) {
    const action = yield take(my_payload_channel);
    
    yield put(action);
  }
}

export function* getUserIP() {
  yield takeLatest(DTActions.REQUEST_USER_IP, function*() {
    try {
      const user_ip = yield call(FetchUserIP);
      
      yield put({
        type: DTActions.USER_IP,
        user_ip,
      });
    } catch (error) {
      console.log("getUserIP", "error", error);

      const user_ip = null;
      yield put({ type: DTActions.USER_IP, user_ip });
    }
  });
}

export function* GetReferralQuote() {
  yield takeLatest(DTActions.FETCH_REFERRAL_QUOTE, function*(value) {
    try {
      
      yield put({
        type: DTActions.IS_FETCHING_REFERRAL_QUOTE,
        is_fetching_referral_quote: true,
      });
      const referral_quote_data = yield call(setReferralView, value.linkId);
      
      yield put({
        type: DTActions.SET_REFERRAL_QUOTE,
        referral_quote_data,
      });
      yield put({
        type: DTActions.IS_FETCHING_REFERRAL_QUOTE,
        is_fetching_referral_quote: false,
      });
    } catch (error) {
      const referral_quote_data = null;
      yield put({
        type: DTActions.SET_REFERRAL_QUOTE,
        referral_quote_data,
      });
      yield put({
        type: DTActions.IS_FETCHING_REFERRAL_QUOTE,
        is_fetching_referral_quote: false,
      });
    }
  });
}

export function* renewPolicy(){
   yield takeLatest(DTActions.RENEW_POLICY, function*(value){
     try{
        yield put({
          type: DTActions.IS_RENEWING_POLICY,
          is_renewing_policy: true,
        });
        const renewedpolicy = yield call(renewPolicyCall, value.transactionId);
        
        yield put({
          type: DTActions.SET_RENEWED_POLICY,
          renewedpolicy,
        });
        yield put({
          type: DTActions.IS_RENEWING_POLICY,
          is_renewing_policy: false,
        });
        yield put({
          type: DTActions.RENEW_POLICY_HAS_BEEN_CALLED,
          renew_has_been_called: false,
        });
      }catch(error){
        const renewedpolicy = false;
        yield put({
          type: DTActions.SET_RENEWED_POLICY,
          renewedpolicy,
        });
        yield put({
          type: DTActions.IS_RENEWING_POLICY,
          is_renewing_policy: false,
        });
      }
   })
}


function* generateIntercomHashSaga(action) {
  try {
    const { email, recaptcha } = action.value
    const { key } = yield FetchIntercomHash(email, recaptcha)
    yield put({ type: DTActions.SET_INTERCOM_HASH, hashData: key });
  } catch (error) {
    yield put({ type: DTActions.SET_INTERCOM_HASH, hashData: null });
  }
}

export function* generateIntercomHash() {
  yield takeLatest(DTActions.GENERATE_INTERCOM_HASH, generateIntercomHashSaga);
}


export default function* rootSaga() {
  yield all([
    fork(GetCarsApiData),
    fork(getUserIP),
    fork(helloSaga),
    fork(GetReferralQuote),
    fork(renewPolicy),
    fork(generateIntercomHash)
  ]);
}
